import React from 'react';
import { personalInfo } from '../data/mock';

const RetroFooter = () => {
  return (
    <footer className="window mt-6">
      <div className="window-header">
        <span>🌟 Thanks for visiting! 🌟</span>
      </div>
      <div className="window-body text-center">
        <div className="mb-4 flex justify-center items-center gap-3">
          <span className="text-4xl animate-bounce">🧚‍♀️</span>
          <span className="text-4xl animate-pulse">✨</span>
          <span className="text-4xl animate-bounce" style={{ animationDelay: '0.3s' }}>💖</span>
          <span className="text-4xl animate-pulse" style={{ animationDelay: '0.5s' }}>🌈</span>
          <span className="text-4xl animate-bounce" style={{ animationDelay: '0.7s' }}>🦄</span>
        </div>
        
        <p className="text-sm mb-2">
          Made with ❤️ by {personalInfo.name}
        </p>
        
        <p className="text-xs text-gray-600 mb-3">
          © {new Date().getFullYear()} | Best viewed in 1024x768 resolution 🕹️
        </p>

        <div className="flex justify-center gap-3 mb-4 text-2xl">
          <span className="animate-pulse">🌟</span>
          <span className="animate-bounce">⭐</span>
          <span className="animate-pulse" style={{ animationDelay: '0.3s' }}>💫</span>
          <span className="animate-bounce" style={{ animationDelay: '0.5s' }}>✨</span>
          <span className="animate-pulse" style={{ animationDelay: '0.7s' }}>🌟</span>
        </div>

        <marquee className="text-xs" behavior="scroll" direction="left">
          ⭐ Thank you for visiting my cyber space! Come back soon! ⭐ 
          🌈 Have a magical day! 🌈 
          ✨ Remember to spread kindness! ✨ 
          🦄 Keep coding and creating! 🦄
        </marquee>
      </div>
    </footer>
  );
};

export default RetroFooter;
